import React, { Suspense } from 'react';
import { GET_CONTACT_HERO } from '../queries/Hero';

import {
  HeroLoading,
  PageContentLoading,
  NewsListLoading
} from '../components/UI/Skeleton/Skeletons';
const Hero = React.lazy(() => import('../components/UI/Hero/Hero'));
const ContactContent = React.lazy(() =>
  import('../components/Contact/ContactContent')
);
const ArticlesPageFooter = React.lazy(() =>
  import('../components/Articles/ArticlesPageFooter')
);

const Contact = () => {
  return (
    <>
      <Suspense fallback={<HeroLoading />}>
        <Hero
          heroContent={'contact'}
          heroQuery={GET_CONTACT_HERO}
          heroClassName={'heroSectionContact'}
        />
      </Suspense>

      <Suspense fallback={<PageContentLoading />}>
        <ContactContent />
      </Suspense>

      <Suspense fallback={<NewsListLoading />}>
        <ArticlesPageFooter />
      </Suspense>
    </>
  );
};

export default Contact;
